import { TableDataValue } from "@/reports/components/ReadingSkillsDataTable";

const renderDataCellLabel = (value: TableDataValue) => {
  return value
    ? `${value.labelValue} question${value.labelValue === 1 ? "" : "s"}`
    : "";
};

export default renderDataCellLabel;
